import { TrashIcon } from '@phosphor-icons/react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import colors from 'tailwindcss/colors';

import { Button } from '@/components/ui/button';
import { useApiMutation } from '@/modules/common';

interface InventoryRemoveButtonProps {
  eventId: string;
  productId: string;
  sizeId: string;
  stationId: string;
}

export function InventoryRemoveButton({
  eventId,
  productId,
  sizeId,
  stationId,
}: InventoryRemoveButtonProps) {
  const queryClient = useQueryClient();

  const removeEventProductMutation = useApiMutation<void>(
    `/events/${eventId}/stations/${stationId}/products/${productId}/sizes/${sizeId}`,
    {
      method: 'DELETE',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const removeInventory = async () => {
    await removeEventProductMutation.mutateAsync();
    queryClient.invalidateQueries({
      queryKey: ['eventProducts', eventId, stationId],
    });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      type="button"
      onClick={removeInventory}
      data-testid="remove-inventory"
    >
      <TrashIcon size={28} color={colors.zinc[400]} />
    </Button>
  );
}
